<template>
  <div class="editor-header-buttons-group">
    <div class="small-buttons-group">
      <!-- Settings button -->
      <a
        class="tab-trigger-btn text-link"
        :class="{ 'tab-trigger-btn--active': isShowSetting }"
        @click="$emit('showSetting')"
        v-tooltip="'Settings'"
      >
        <aha-icon
          name="setting"
          viewBox="0 0 24 24"
          width="18"
          height="18"
        />
      </a>

      <!-- Results button -->
      <a
        @click="$emit('showExport')"
        class="tab-trigger-btn text-link"
        :class="{ 'tab-trigger-btn--active': isShowResult }"
        v-tooltip="'Results'"
      >
        <aha-icon
          name="download"
          viewBox="0 0 24 24"
          width="18"
          height="18"
        />
      </a>
    </div>

    <div class="preview-present-buttons-group">
      <PreviewButton class="hidden -mt-1 sm:block lg:ml-2" />
      <span class="hidden -mt-1 sm:inline">
        <aha-button
          class="aha-button-present"
          :disabled="isNewPresentation || isDisableEditPresentation"
          @mouseup.stop
        >
          <span
            class="flex items-center
                justify-center pl-2.5 pr-1.5 py-1.5"
            @click="onClickPresentButton"
          >
            <span class="w-5 h-5">
              <aha-icon
                name="play"
                viewBox="0 0 24 24"
                width="15"
                height="15"
                v-if="!waitPresenting"
              />
              <aha-spinner variant="white" v-else />
            </span>
            <span class="ml-1">Present</span>
          </span>

          <span
            class="h-6 border-r no-margin border-primary-100"
            @click="onClickPresentButton"
          />

          <!-- dropdown trigger -->
          <span
            class="hidden sm:block no-margin pl-1 pr-2.5 py-1.5"
            @click="$emit('togglePresentOptions')"
            @mouseup.stop
          >
            <span>
              <aha-icon
                name="arrow"
                width="14"
                height="14"
                viewBox="0 0 24 24"
              />
            </span>
          </span>
        </aha-button>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Utils from '@/util'
import gaCategories from '@/constant/gaCategories.js'
import mixpanelUtils from '@/utils/mixpanel.utils'
import PreviewButton from '@/components-v2/presentation-editor/middle/PreviewButton.vue'

const iconOpenLink = require('@/assets/images/vector.svg')

export default {
  components: {
    PreviewButton,
  },
  props: {
    waitPresenting: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      tooltipHelp: {
        content: `<img src="${iconOpenLink}" class="inline-block relative -top-0.5"></i> This link opens in a new tab`,
      },
    }
  },
  computed: {
    ...mapState({
      isNewPresentation: (state) => state.isNewPresentation,
      presentation: (state) => state.presentation,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      isReferPublicTemplate: (state) => state.isReferPublicTemplate,
    }),
    isShowSetting() {
      return this.presentation.id && this.presentation.showSetting
    },
    isShowResult() {
      return this.presentation.id && this.presentation.showExport
    },
  },
  methods: {
    onClickPresentButton() {
      if (this.waitPresenting) {
        return
      }
      const customProps = {
        ...mixpanelUtils.getPresentationContext(this.presentation),
        ...Utils.getSlideCountObject(this.presentation),
      }
      this.$emit('startPresentingMode')
      Utils.gaTrackEvent(
        gaCategories.PRESENTATION_EDITOR,
        'start presenting',
        'Presentation Editor > Present Button',
        this.presentation.id,
        customProps,
      )
      if (this.isReferPublicTemplate) {
        Utils.gaTrackEvent('Public template > Demo mode', 'Start presenting')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss-v2/variables.scss";

.editor-header-buttons-group {
  @apply flex items-center justify-end md:justify-between;
  .small-buttons-group {
    @apply hidden md:flex items-center justify-between;
  }

  &.backstage-buttons {
    @apply justify-end;
  }
}
.tab-trigger-btn {
  @apply relative top-1.5 items-center px-1.5 xl:px-2 pt-2 pb-6;
  // only apply transition to color. Prevent wierd background flicker when applying --active class
  transition-property: color;

  &--active {
    @apply z-20 bg-base-0 rounded-t-md text-primary-100;
  }
}
.preview-present-buttons-group {
  @apply flex gap-x-3;
}
.aha-button-present {
  @apply relative flex items-center justify-center p-0;
  span.no-margin {
    margin-left: 0;
  }
}
</style>
